module.exports = __webpack_public_path__ + "static/img/skill.9842762c.svg";